import { render, staticRenderFns } from "./CreatePots.vue?vue&type=template&id=3bb30af2&"
import script from "./CreatePots.vue?vue&type=script&lang=js&"
export * from "./CreatePots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports